module.exports = {
  "country": "CH",
  "artist": "Timebelle",
  "song": "Apollo",
  "year": "2017",
  "place": "NQ",
  "spotify": "1YySksBo8O9tdgBcdPIIWw"
};